import { trackAbTestV2Variant } from 'dibs-ab-tests/exports/clientAbTestV2.ts';
import { trackEvent, trackEcommerce, trackingConstants, eventNameConstants } from 'dibs-tracking';

export const HP_RV_NEW_ARRIVALS_TEST_NAME = 'HP_RVNewArrivals_Jan2026';
const ACTION_LABEL = 'new arrivals';
const LIST_NAME = 'new arrivals items carousel';

const { ECOM_PRODUCT_CLICK, ECOM_PRODUCT_IMPRESSION } = trackingConstants;
const { EVENT_SELECT_ITEM, EVENT_VIEW_ITEM_LIST } = eventNameConstants;

type NewArrivalsItem = {
    itemId: string;
    itemTitle: string;
    brand?: string | null;
    category?: string | null;
    categoryCode?: string | null;
    contemporaryTrackingString?: string | null;
};

export const trackHpRvNewArrivalsVariant = (): void => {
    trackAbTestV2Variant(HP_RV_NEW_ARRIVALS_TEST_NAME);
};

const trackInteraction = ({ action, label }: { action: string; label: string }): void => {
    trackEvent({
        category: 'promo interaction',
        action,
        label,
        value: 0,
    });
};

export const trackNewArrivalsViewMoreClick = (): void => {
    trackInteraction({
        action: 'new arrivals view more clicked',
        label: '[homepage]',
    });
};

export const trackNewArrivalsArrowClick = ({ direction }: { direction: string }): void => {
    trackInteraction({
        action: 'new arrivals items arrow clicked',
        label: direction,
    });
};

export const trackNewArrivalsInitialDisplay = ({
    itemsReturned,
}: {
    itemsReturned: number;
}): void => {
    trackInteraction({
        action: 'new arrivals items displayed',
        label: itemsReturned.toString(),
    });
};

const trackNewArrivalsItem = ({
    type,
    eventName,
    item,
    index,
}: {
    type: typeof ECOM_PRODUCT_CLICK | typeof ECOM_PRODUCT_IMPRESSION;
    eventName: typeof EVENT_SELECT_ITEM | typeof EVENT_VIEW_ITEM_LIST;
    item: NewArrivalsItem;
    index: number;
}): void => {
    const actionField: { list: string; itemId?: string } = { list: LIST_NAME };
    if (eventName === EVENT_SELECT_ITEM) {
        actionField.itemId = item.itemId;
    }
    trackEcommerce({
        type,
        eventName,
        actionField,
        products: [
            {
                brand: item.brand,
                category: item.category,
                categoryCode: item.categoryCode,
                dimension83: item.contemporaryTrackingString,
                id: item.itemId,
                name: item.itemTitle,
                list: LIST_NAME,
                position: index + 1,
                variant: 'homepage',
            },
        ],
        trigger: ACTION_LABEL,
    });
};

export const trackNewArrivalsItemClick = ({
    item,
    index,
}: {
    item: NewArrivalsItem;
    index: number;
}): void => {
    trackInteraction({
        action: 'new arrivals items item clicked',
        label: 'none',
    });
    trackNewArrivalsItem({
        type: ECOM_PRODUCT_CLICK,
        eventName: EVENT_SELECT_ITEM,
        item,
        index,
    });
};

export const trackNewArrivalsItemImpression = ({
    item,
    index,
}: {
    item: NewArrivalsItem;
    index: number;
}): void => {
    trackNewArrivalsItem({
        type: ECOM_PRODUCT_IMPRESSION,
        eventName: EVENT_VIEW_ITEM_LIST,
        item,
        index,
    });
};
